"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const PenDraw_1 = __importDefault(require("../PenDraw"));
const StickyCard_1 = __importDefault(require("../StickyCard"));
const StickyDragOverlay_1 = __importDefault(require("../StickyDragOverlay"));
const react_router_dom_1 = require("react-router-dom");
const i18n_1 = require("@completeanatomy/i18n");
const bridge_1 = require("@completeanatomy/bridge");
const ui_1 = require("@completeanatomy/ui");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const atoms_1 = require("../../atoms");
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const StickyCardResizer_1 = __importDefault(require("../StickyCardResizer"));
const hooks_1 = require("../../hooks");
const providers_1 = require("../../providers");
// eslint-disable-next-line max-lines-per-function
function SketchCard({ identifier, rect, color = '', size = 0, selectedToolType, setSelectedID, setSelectedType, isEditable = true, }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const drawRef = (0, react_1.useRef)(null);
    const bridge = (0, bridge_1.useBridge)();
    const touchEventsSupported = (0, ui_1.isTouchEventsSupported)();
    const tools = (0, providers_1.useToolsService)();
    const stickies = (0, hooks_1.useStickiesState)();
    const sticky = stickies.find(s => s.identifier === identifier);
    const selectedId = (0, hooks_1.useSelectedID)();
    const navigateToSketch = (0, react_1.useCallback)(() => {
        if (selectedToolType !== bridge_schema_1.ToolType.StickyHandWriting) {
            bridge === null || bridge === void 0 ? void 0 : bridge.toolSelect(bridge_schema_1.ToolType.StickyHandWriting);
            tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().selectSticky(identifier);
            if (setSelectedType) {
                setSelectedType(bridge_schema_1.ToolType.StickyHandWriting);
            }
            // @ts-ignore
            window.toolkitPanelDelegate.activate(bridge_schema_1.ToolType.StickyHandWriting);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        navigate,
        selectedToolType,
        bridge,
        setSelectedID,
        setSelectedType,
        identifier,
    ]);
    const onClick = (0, react_1.useCallback)(() => {
        if (setSelectedID) {
            setSelectedID(identifier);
        }
        tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().selectSticky(identifier);
        if (selectedId !== identifier && selectedToolType !== bridge_schema_1.ToolType.None) {
            // navigateToSketch();
            if (setSelectedType) {
                setSelectedType(bridge_schema_1.ToolType.None);
            }
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        identifier,
        navigateToSketch,
        selectedId,
        selectedToolType,
        setSelectedID,
        setSelectedType,
    ]);
    const onDoubleClick = (0, react_1.useCallback)(() => {
        navigateToSketch();
    }, [navigateToSketch]);
    const onResizing = (0, react_1.useCallback)((newSize) => {
        tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().updateSticky({
            identifier,
            stickyRect: {
                width: newSize.width,
                height: newSize.height,
            },
        });
    }, [tools, identifier]);
    const onResizeEnd = (0, react_1.useCallback)((newSize) => {
        tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().updateSticky({
            identifier,
            stickyRect: {
                width: newSize.width,
                height: newSize.height,
            },
        });
    }, [tools, identifier]);
    const onPaintEnd = (newCurves) => {
        tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().updateSticky({ identifier, curves: newCurves });
    };
    const onDelete = () => {
        tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().removeSticky(identifier);
        if (selectedToolType !== bridge_schema_1.ToolType.None) {
            bridge === null || bridge === void 0 ? void 0 : bridge.toolSelect(bridge_schema_1.ToolType.None);
            navigate(-1);
        }
    };
    const onResizeAction = (0, react_1.useCallback)((action, newSize) => {
        if (action === ui_1.ActionType.DRAG) {
            onResizing(newSize);
        }
        if (action === ui_1.ActionType.MOUSE_UP) {
            const updatedStickyRect = Object.assign(Object.assign({}, sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect), newSize);
            tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().updateSticky({
                identifier,
                stickyRect: updatedStickyRect,
            });
            onResizeEnd(newSize);
        }
    }, [onResizing, identifier, onResizeEnd, tools, sticky]);
    const setCurvesWrapper = (curvesUpdate) => {
        var _a;
        let newCurves;
        if (typeof curvesUpdate === 'function') {
            newCurves = curvesUpdate((_a = sticky === null || sticky === void 0 ? void 0 : sticky.curves) !== null && _a !== void 0 ? _a : []);
        }
        else {
            newCurves = curvesUpdate;
        }
        tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().updateSticky({ identifier: identifier, curves: newCurves });
    };
    const isSelected = selectedId === identifier;
    const isOverlayVisible = selectedToolType === bridge_schema_1.ToolType.None && isSelected && isEditable;
    const isCanDraw = selectedToolType === bridge_schema_1.ToolType.StickyHandWriting && isSelected;
    const isCanDrag = selectedToolType !== bridge_schema_1.ToolType.StickyHandWriting ||
        (selectedToolType === bridge_schema_1.ToolType.StickyHandWriting && !isSelected);
    return ((0, jsx_runtime_1.jsxs)(StyledStickyCard, { identifier: identifier, rect: rect, canDrag: isCanDrag, onClick: onClick, onDoubleClick: onDoubleClick, onResizing: onResizing, onResizeEnd: onResizeEnd, "data-e2e": 'SketchCard_StyledStickyCard', children: [(0, jsx_runtime_1.jsx)(PenDraw_1.default, { ref: drawRef, curves: (_a = sticky === null || sticky === void 0 ? void 0 : sticky.curves) !== null && _a !== void 0 ? _a : [], width: (_b = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect.width) !== null && _b !== void 0 ? _b : 0, height: (_c = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect.height) !== null && _c !== void 0 ? _c : 0, color: color, size: size, opacity: 1, offset: {
                    x: (_e = (_d = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect) === null || _d === void 0 ? void 0 : _d.x) !== null && _e !== void 0 ? _e : 0,
                    y: (_g = (_f = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect) === null || _f === void 0 ? void 0 : _f.y) !== null && _g !== void 0 ? _g : 0,
                }, drawable: isCanDraw, drawOutside: true, onPaintEnd: onPaintEnd, setCurves: setCurvesWrapper, isGlobalPen: false, "data-e2e": 'SketchCard_PenDrawPanel' }), isOverlayVisible && ((0, jsx_runtime_1.jsx)(StyledStickyDragOverlay, { hint: touchEventsSupported
                    ? (0, i18n_1.Localized)(i18n_1.Strings.tools.sketch.dragPlaceholderTouch)
                    : (0, i18n_1.Localized)(i18n_1.Strings.tools.sketch.dragPlaceholder), "data-e2e": 'SketchCard_StyledStickyDragOverlay' })), (0, jsx_runtime_1.jsx)(StyledDeleteStickyButton, { "$visible": isSelected, onClick: onDelete, "data-e2e": 'SketchCard_StyledDeleteStickyButton' }), (0, jsx_runtime_1.jsx)(StickyCardResizer_1.default, { size: {
                    width: (_h = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect.width) !== null && _h !== void 0 ? _h : 0,
                    height: (_j = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect.height) !== null && _j !== void 0 ? _j : 0,
                }, visible: isSelected, onResizeAction: onResizeAction, "data-e2e": 'SketchCard_StickyCardResizer' })] }, `${(_k = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect) === null || _k === void 0 ? void 0 : _k.x}-${(_l = sticky === null || sticky === void 0 ? void 0 : sticky.stickyRect) === null || _l === void 0 ? void 0 : _l.y}`));
}
exports.default = (0, react_1.memo)(SketchCard, (prevProps, nextProps) => {
    return (0, isEqual_1.default)(prevProps, nextProps);
});
const StyledStickyCard = (0, styled_components_1.default)(StickyCard_1.default) `
  padding: 0;
`;
const StyledStickyDragOverlay = (0, styled_components_1.default)(StickyDragOverlay_1.default) `
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
const StyledDeleteStickyButton = (0, styled_components_1.default)(atoms_1.DeleteStickyButton) `
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};

  transition: opacity 0.2s;

  pointer-events: ${({ $visible }) => ($visible ? 'all' : 'none')};
`;
